export default {
  install(Vue) {
    Vue.prototype.$message = new Vue({
      data() {
        return {
          variant: "",
          content: "",
          showing: false
        };
      },

      methods: {
        hide() {
          this.showing = false;
        },
        show({ msg, variant }) {
          this.content = msg;
          this.variant = variant;
          this.showing = true;

          setTimeout(() => {
            this.showing = false;
          }, 10 * 1000);
        },
        success(msg) {
          const variant = "success";
          this.show({ msg, variant });
        },
        warning(msg) {
          const variant = "warning";
          this.show({ msg, variant });
        },
        error(msg) {
          const variant = "danger";
          this.show({ msg, variant });
        }
      }
    });
  }
};
